(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncButton = (button, video) => {
    const muted = video.muted;
    button.setAttribute('aria-pressed', String(!muted));
    const label = button.querySelector('[data-ugc-sound-label]');
    if (label) label.textContent = muted ? 'SOUND ON' : 'SOUND OFF';
  };

  const initialise = (root = document) => {
    root.querySelectorAll('[data-fw-ugc-proof]').forEach((section) => {
      section.querySelectorAll('[data-ugc-sound-toggle]').forEach((button) => {
        if (button.dataset.ugcReady === 'true') return;
        const media = button.closest('.fw-home-v2-ugc-proof__media');
        const video = media?.querySelector('video');
        if (!video) return;

        button.dataset.ugcReady = 'true';
        video.muted = true;
        syncButton(button, video);
        button.addEventListener('click', () => {
          video.muted = !video.muted;
          if (video.paused && !reduceMotion.matches) video.play().catch(() => {});
          syncButton(button, video);
        });
      });

      if (reduceMotion.matches) {
        section.querySelectorAll('video').forEach((video) => {
          video.autoplay = false;
          video.pause();
        });
      }
    });
  };

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

